module.exports = __webpack_public_path__ + "img/variable.395a5eb1.png";